import axios from 'axios'
import { Message } from 'element-ui';
import { utils } from './common'

var local_base_url = 'http://10.10.1.118:10050';  // 本地
var dev_base_url  = 'http://10.10.1.143:10050';  //dev
var test_base_url = 'https://api.test.ysintelligent.com/fzzht/web'; //test
var prod_base_url = 'https://api.ysintelligent.com/fzzht/web';

// 静态资源前缀 - oss
var local_file_prefix_url = 'http://10.10.1.240:8888';
var dev_file_prefix_url = 'http://10.10.1.240:8888';
var test_file_prefix_url = 'https://oss.test.yijiajiayun.com';
var prod_file_prefix_url = 'https://oss.yijiajiayun.com';

// 静态资源前缀 - oss
var dev_image_security_Key = 'vLZo4cqxmhA5klyWyXW5';
var test_image_security_Key = 'tqZcNGVyGdVPpQmrqzrD';
var prod_image_security_Key = 'xjwXvByGleYjRZOuu5dO';

//根据环境 改变接口地址
var environmental= utils.getCurrentApi()
var resultApi={}
if(environmental=='local') {
  resultApi = {
    baseUrl: local_base_url, 
    filePrefixUrl: local_file_prefix_url,
    imageSecurityKey: dev_image_security_Key
  }
}
if(environmental=='dev'){
  resultApi = {
    baseUrl: dev_base_url, 
    filePrefixUrl: dev_file_prefix_url,
    imageSecurityKey: dev_image_security_Key
  }
}
if(environmental=='test'){
  resultApi = {
    baseUrl: test_base_url, 
    filePrefixUrl: test_file_prefix_url,
    imageSecurityKey: test_image_security_Key
  }
}
if(environmental=='prod'){
  resultApi = {
    baseUrl: prod_base_url, 
    filePrefixUrl: prod_file_prefix_url,
    imageSecurityKey: prod_image_security_Key
  }
}

export const api = resultApi

function createRequest(baseURL) {
    // 创建axios实例
    const request = axios.create({
        // API 请求的默认前缀
        baseURL: baseURL || resultApi.baseUrl,
        // 请求超时时间
        timeout: 10000,
    })

    request.interceptors.response.use(response => {
        // 对响应数据做点什么
        if (!response.data.erroyCode) {
          Message({
            message: "网络异常，请稍后重试",
            type: 'error',
            duration: 2000
          });
        }
        return response.data
    }, error => {
        // 对响应错误做点什么
        Message({
					message: "网络异常，请稍后重试",
					type: 'error',
					duration: 2000
				});
        return Promise.reject(error)
    })

    return request
}

export const request = createRequest()





// WEBPACK FOOTER //
// ./src/common/request_course.js